(() => {
    const AUTO_INTERVAL_MS = 5000;
    const INITIAL_DELAY_MS = 20000;
  const RESUME_DELAY_MS = 4000;

  document.querySelectorAll('[data-deal-week-mobile]').forEach((root) => {
    const track = root.querySelector('[data-deal-week-track]');
    if (!track || track.children.length <= 1) return;

    track.setAttribute('tabindex', '0');
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', root.dataset.dealWeekLabel || 'Weekly deals');
    track.setAttribute('aria-live', 'polite');

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) return;

    const slides = [...track.children];
    let activeIndex = 0;
    let timer = null;
    let paused = false;
    let resumeTimer = null;

    const slideWidth = () => track.clientWidth || 1;

    const syncIndexFromScroll = () => {
      const nextIndex = Math.round(track.scrollLeft / slideWidth());
      if (nextIndex >= 0 && nextIndex < slides.length) {
        activeIndex = nextIndex;
      }
    };

    const scrollToIndex = (index, smooth = true) => {
      const target = ((index % slides.length) + slides.length) % slides.length;
      const wrapToStart = activeIndex === slides.length - 1 && target === 0;

      if (wrapToStart) {
        track.classList.add('is-instant-scroll');
        track.scrollTo({ left: 0, behavior: 'auto' });
        track.classList.remove('is-instant-scroll');
      } else {
        if (!smooth) track.classList.add('is-instant-scroll');
        track.scrollTo({
          left: target * slideWidth(),
          behavior: smooth ? 'smooth' : 'auto',
        });
        if (!smooth) {
          window.requestAnimationFrame(() => track.classList.remove('is-instant-scroll'));
        }
      }

      activeIndex = target;
    };

    const advance = () => {
      if (paused) return;
      scrollToIndex(activeIndex + 1, true);
    };

    const stopAuto = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const startAuto = (deferFirst = false) => {
      stopAuto();
      const arm = () => {
        if (paused) return;
        timer = window.setInterval(advance, AUTO_INTERVAL_MS);
      };
      if (!deferFirst) {
        arm();
        return;
      }
      timer = window.setTimeout(() => {
        if (paused) return;
        advance();
        arm();
      }, INITIAL_DELAY_MS);
    };

    const pauseAuto = () => {
      paused = true;
      stopAuto();
      if (resumeTimer) window.clearTimeout(resumeTimer);
    };

    const scheduleResume = () => {
      if (resumeTimer) window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(() => {
        paused = false;
        syncIndexFromScroll();
        startAuto();
      }, RESUME_DELAY_MS);
    };

    track.addEventListener(
      'scroll',
      () => {
        window.requestAnimationFrame(syncIndexFromScroll);
      },
      { passive: true }
    );

    track.addEventListener('touchstart', pauseAuto, { passive: true });
    track.addEventListener('mousedown', pauseAuto);
    track.addEventListener('wheel', pauseAuto, { passive: true });
    track.addEventListener('keydown', pauseAuto);
    track.addEventListener('touchend', scheduleResume, { passive: true });
    track.addEventListener('mouseup', scheduleResume);
    track.addEventListener('keyup', scheduleResume);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        pauseAuto();
      } else {
        scheduleResume();
      }
    });

    window.addEventListener(
      'resize',
      () => {
        scrollToIndex(activeIndex, false);
      },
      { passive: true }
    );

    startAuto(true);
  });
})();
